module.exports = __webpack_public_path__ + "img/top-companies-logos.30a6634b.png";